import { z } from "zod";
const flowTypeSchema = z.enum(["split", "recursive", "others"]);
export const baseHeaderSchema = z.object({
  label: z.string().min(1),
  keyValue: z.string().min(1),
  key: z.string(),
  flowType: z.array(flowTypeSchema).optional(),
  hide: z.boolean().optional().default(false),
  readonly: z.boolean().optional().default(false),
  required: z.boolean().optional().default(false),
  disabled: z.boolean().optional().default(false),
});
